import React from 'react';
import classes from './StatsCard.module.css';
import CommonCard from '../CommonCard';
import clsx from 'clsx';
import StatsCardSkeleton from '../StatsCardSkeleton';
const StatsCard = ({ content, bottom, cardName, sessionActive }) => {
  return (
    <>
      {sessionActive ? (
        <CommonCard
          className={clsx(classes.card, {
            [classes.cashFlow]: ['Cash Flow', 'Payments'].includes(cardName),
            [classes.totalPatients]: cardName == 'Total Patients',
            [classes.newPatients]: cardName == 'New Patients',

            [classes.followUp]: cardName === 'Follow-up'
          })}>
          <h2 className={classes.heading}>{cardName}</h2>
          <h3 className={classes.amountHeading}>{content ? content : ''}</h3>
          <p className={classes.waived}>{bottom ? bottom : ''}</p>
        </CommonCard>
      ) : (
        <StatsCardSkeleton cardName={cardName} />
      )}
    </>
  );
};

export default StatsCard;
